import { render, staticRenderFns } from "./AppNotification.vue?vue&type=template&id=378a176b&"
import script from "./AppNotification.vue?vue&type=script&lang=js&"
export * from "./AppNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('378a176b')) {
      api.createRecord('378a176b', component.options)
    } else {
      api.reload('378a176b', component.options)
    }
    module.hot.accept("./AppNotification.vue?vue&type=template&id=378a176b&", function () {
      api.rerender('378a176b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/AppNotification.vue"
export default component.exports